import {Link} from 'react-router-dom'
import './index.css'

const TeamCard = props => {
  const {details} = props
  const {name, id, teamImageUrl} = details

  return (
    <Link className="card-link" to={`/team-matches/${id}`}>
      <li className="team-card">
        <img className="home-team-logo" alt={name} src={teamImageUrl} />
        <p className="home-team-name">{name}</p>
      </li>
    </Link>
  )
}

export default TeamCard
